module.exports = __webpack_public_path__ + "img/Maskgroup.d09c0fd6.png";